angular.module('unica_workshop_session.workshop_session_services')

.factory('WorkshopSessionEditService', function ($http, getBaseApiURL) {

	var workshopSessionEditService = {};

	workshopSessionEditService.update = function (workshopSessionData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/workshop-session/update/' + workshopSessionData.id,
			data: workshopSessionData
		}).then(function(result) {

			if ( result ) {
				return result.data.workshop_session;
			}

		});

	};

	return workshopSessionEditService;
});